import React, { useRef, useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

function Clock() {
	const [mouseData, setMouseData] = useState({ x: 0, y: 0 });
	const canvasRef = useRef(null);
	const [canvasCTX, setCanvasCTX] = useState(null);
	const [color, setColor] = useState('#333333');
	const [size, setSize] = useState(3);
 
	useEffect(() => {
		const canvas = canvasRef.current;
		const ctx = canvas.getContext('2d');
		canvas.width = window.innerWidth;
		canvas.height = window.innerHeight;
		setCanvasCTX(ctx);
	}, [canvasRef]);
 
	const SetPos = (e) => {
		setMouseData({
			x: e.clientX,
			y: e.clientY
		});
		Draw(e);
	};
 
	const Draw = (e) => {
		const ctx = canvasCTX;
		ctx.beginPath();
		ctx.moveTo(mouseData.x, mouseData.y);
		setMouseData({
			x: e.clientX,
			y: e.clientY
		});
		ctx.lineTo(e.clientX, e.clientY);
		ctx.strokeStyle = color;
		ctx.lineWidth = size;
		ctx.lineCap = 'round';
		ctx.stroke();
	};

  return (
    <>
      <div
        style={{
          mixBlendMode: "multiply",
          display: "block",
          position: 'fixed',
          top: 0,
          left: 0,
          zIndex: 9999,
          pointerEvents: 'none',          
        }} 
      >
        <canvas
          ref={canvasRef}
          onMouseEnter={(e) => SetPos(e)}
          onMouseDown={(e) => SetPos(e)}
          onMouseMove={(e) => Draw(e)}
        ></canvas>
      </div>
      
      <Container fluid 
        className="home-section" id="home" 
        onMouseEnter={(e) => SetPos(e)}
        onMouseDown={(e) => SetPos(e)}
        onMouseMove={(e) => Draw(e)}
      >
      <header>
        <nav>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/project">Projects</Link></li>
            <li><Link to="/about">About</Link></li>
            <li className="active-page">(Here)</li>
          </ul>
        </nav>
      </header>
      <Container className="home-content">
        <Row>
          <Col md={{span: 8, order:1}} xs={{span: 12, order:2}} className="home-about-description">
            <p>
              The squares are a clock.
            </p>
            <p>
              The first square represents the hour (0-23), cycling through the color spectrum over 24 hours.
            </p>
            <p>
              The second square represents the minute (0-59), cycling through the color spectrum every hour.
            </p>
            <p>
              Together, they display the current time through color.
            </p>
          </Col>
        </Row>
      </Container>
    </Container>
    </>
  );
}

export default Clock;

